export class UserInputValidator {
  private maxLen: number
  constructor() {
    this.maxLen = 1000
  }

  public validate(s: string): string {
    if (s === '' || s === null) return ''
    const res = this.filterSpecialChars(s)
    return res
  }

  private filterSpecialChars(s: string): string {
    const scChars = [
      '~',
      '`',
      '!',
      '@',
      '#',
      '$',
      '%',
      '^',
      '&',
      '*',
      '(',
      ')',
      '_',
      '-',
      '+',
      '=',
      '{',
      ' [',
      '}',
      ']',
      '|',
      '(',
      '\\',
      ':',
      ';',
      '"',
      '\'',
      '<',
      ',',
      '>',
      '/',
    ]
    let ca = [...s]
    ca = ca.reverse()
    const N = Math.min(ca.length, this.maxLen)
    const filtered = []
    for (let i = N - 1; i >= 0; i--) {
      // @ts-expect-error - TODO: fix this
      if (!scChars.includes(ca[i])) {
        filtered.push(ca[i])
      }
    }
    return filtered.join('')
  }

  public setMaxLen(n: number) {
    if (n > this.maxLen || n < 0) {

    }
    else {
      this.maxLen = n
    }
  }
}
